import { render, staticRenderFns } from "./VectorMaps.vue?vue&type=template&id=5ebbd6b4&scoped=true"
import script from "./VectorMaps.vue?vue&type=script&lang=js"
export * from "./VectorMaps.vue?vue&type=script&lang=js"
import style0 from "./VectorMaps.vue?vue&type=style&index=0&id=5ebbd6b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebbd6b4",
  null
  
)

export default component.exports